import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { NotificationService } from '../../core/services/notification.service';
import { TransactionService } from '../../core/services/transaction.service';
import { StudioService } from '../../core/services/studio.service';
import { LockerNumberService } from '../../core/services/locker-number.service';
import { FormFeedback } from '../../shared/components/form-feedback.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-notification-locker',
    imports: [RouterLink, FormsModule, DatePipe, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <form #notificationForm="ngForm" novalidate name="notificationForm" class="col-md-12" (ngSubmit)="save(notificationForm)">
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <div class="row">
          <div class="col-md-3 text-md-right">会員ID：</div>
          <div class="col-md-3 form-group">{{ member?.memberCode }}</div>
          <div class="col-md-3 text-md-right">会員氏名：</div>
          <div class="col-md-3 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
          <div class="col-md-3 text-md-right">店舗：</div>
          <div class="col-md-3 form-group">{{ member?.studio?.name }}</div>
          <div class="col-md-3 text-md-right">状態：</div>
          <div class="col-md-3 form-group">
            @if (member?.status == 0) { <span>在籍中</span> }
            @if (member?.status == 1) { <span>停止</span> }
            @if (member?.status == 2) { <span>停止（除名）</span> }
          </div>
          <div class="col-md-3 text-md-right">区分コース：</div>
          <div class="col-md-3 form-group">{{ member?.studioPlan?.name }}</div>
          <div class="col-md-3 text-md-right">支払方法：</div>
          <div class="col-md-3 form-group">
            @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
            @if (member?.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
          </div>
          <div class="col-md-3 text-md-right">ロッカー：</div>
          <div class="col-md-3 form-group">
            @if (member?.lockerNumber == null) { <span>使用しない</span> }
            @if (member?.lockerNumber != null) { <span>{{ member?.lockerNumber?.product?.name }}</span> }
          </div>
          <div class="col-md-3 text-md-right">保険適応：</div>
          <div class="col-md-3 form-group">
            @if (member?.isInsured == 0) { <span>なし</span> }
            @if (member?.isInsured == 1) { <span>あり</span> }
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">ロッカー</label>
                <select class="form-control" [(ngModel)]="select.isUseLocker" (ngModelChange)="clearSelect()" name="isUseLocker" required>
                  <option [ngValue]="null">選択してください</option>
                  <option [ngValue]="'0'">ロッカーを使用する</option>
                  <option [ngValue]="'1'">ロッカーを使用しない</option>
                </select>
              </div>
            </div>
            @if (select.isUseLocker == '0') {
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">ロッカー月額タイプ</label>
                  <select class="form-control" [(ngModel)]="select.lockerPlanProduct" (ngModelChange)="select.lockerNumber = null" name="lockerPlanProduct" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (product of lockerPlanProducts; track product.id) {
                      <option [ngValue]="product">{{ formatLockerProduct(product) }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">ロッカー番号</label>
                  <select class="form-control" [(ngModel)]="select.lockerNumber" name="lockerNumber" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (item of filteredLockerItems; track item.id) {
                      <option [ngValue]="item">{{ item.lockerNumber }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">使用開始日</label>
                  <select class="form-control" [(ngModel)]="select.startDate" name="startDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of startDateOptions; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            }
            @if (select.isUseLocker == '1') {
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="col-form-label">最終使用月</label>
                  <select class="form-control" [(ngModel)]="select.endDate" name="endDate" required>
                    <option [ngValue]="null">選択してください</option>
                    @for (opt of endDateOptions; track opt.id) {
                      <option [ngValue]="opt">{{ opt.name }}</option>
                    }
                  </select>
                </div>
              </div>
            }
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">現ロッカー価格での最終お支払日：
                  @if (select.isUseLocker && member?.isUseLocker == 0) {
                    <span>{{ formatBillingDate(selectedLockerLastBillingMonth) }}</span>
                  }
                </label>
              </div>
              @if (select.isUseLocker == '0') {
                <div class="col-md-12">
                  <label class="col-form-label">
                    変更先ロッカー価格での初回お支払日：{{ formatBillingDate(select.startDate?.firstBillingMonth) }}
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
        <br /><br />
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/notification', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            <button type="submit" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed || member?.status != 0"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class NotificationLockerComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private notificationService = inject(NotificationService);
  private flash = inject(FlashService);
  private transactionService = inject(TransactionService);
  private studioService = inject(StudioService);
  private lockerNumberService = inject(LockerNumberService);
  private route = inject(ActivatedRoute);

  private batchDay = 11;
  memberId!: number;
  member: any = null;
  select: any = { isUseLocker: null, lockerPlanProduct: null, startDate: null, endDate: null, lockerNumber: null };
  startDateOptions: any[] = [];
  endDateOptions: any[] = [];
  products: any[] = [];
  lockerItems: any[] = [];
  saving = false;
  completed = false;

  get lockerPlanProducts(): any[] {
    return this.products.filter((product) => Number(product?.productType) === 3);
  }

  get filteredLockerItems(): any[] {
    const productId = this.select.lockerPlanProduct?.id;
    if (!productId) return [];
    return this.lockerItems.filter((item) => Number(item?.product?.id ?? item?.productId) === Number(productId));
  }

  get selectedLockerLastBillingMonth(): any {
    return this.select.endDate?.lastBillingMonth ?? this.select.startDate?.lastBillingMonth ?? null;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別諸届申請', 'fa fa-inbox');
    this.memberId = +this.route.snapshot.params['memberId'];
    this.batchDay = await this.transactionService.getBatchSchedule().catch(() => 11) ?? 11;
    this.member = await this.memberService.getOne(this.memberId);
    this.startDateOptions = this.buildStartDateOptions(this.batchDay);
    this.endDateOptions = this.buildEndDateOptions(this.batchDay);
    const studioId = this.member?.studio?.id ?? this.member?.studioId;
    if (studioId) {
      const [lockerItems, products]: any[] = await Promise.all([
        this.studioService.getLockerNumber(studioId).catch(() => []),
        this.studioService.getProduct(studioId).catch(() => []),
      ]);
      this.lockerItems = Array.isArray(lockerItems)
        ? lockerItems.filter((item) => item.memberId === null || item.memberId === this.member?.id)
        : [];
      this.products = Array.isArray(products)
        ? products.filter((product) => Number(product?.status) === 0)
        : [];
    }
  }

  clearSelect(): void {
    this.select.lockerPlanProduct = null;
    this.select.lockerNumber = null;
    this.select.startDate = null;
    this.select.endDate = null;
  }

  formatLockerProduct(product: any): string {
    const amount = Number(product?.amount ?? 0);
    const rate = Number(product?.taxRate?.rate ?? 0);
    const taxedAmount = Math.floor(amount * (1 + rate)).toLocaleString('ja-JP');
    return `(\u00a5${taxedAmount}) ${product?.name ?? ''}`;
  }

  formatBillingDate(value: any): string {
    if (!value) return '';
    const d = new JstDate(value);
    const y = d.getFullYear();
    const m = ('0' + (d.getMonth() + 1)).slice(-2);
    if (this.member?.payment?.paymentMethod == 0) return `${y}年${m}月末`;
    return `${y}年${m}月${d.getDate()}日`;
  }

  buildStartDateOptions(batchDay: number): any[] {
    const now = new JstDate();
    const paymentModify = Number(this.member?.payment?.paymentMethod ?? 0);
    const options = [];
    for (let i = 0; i < 14; i++) {
      const d = new JstDate(now.getFullYear(), now.getMonth(), now.getDate() + i);
      const str = [String(d.getFullYear()), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)];
      const startDateModify = now.getMonth() === d.getMonth() && batchDay <= d.getDate() ? 1 : 0;
      const billingMonthModify = paymentModify + startDateModify;
      options.push({
        id: str.join('-'),
        name: `${str[0]}年${str[1]}月${str[2]}日`,
        date: d,
        lastBillingMonth: new JstDate(d.getFullYear(), d.getMonth() - 1 + billingMonthModify),
        firstBillingMonth: new JstDate(d.getFullYear(), d.getMonth() + billingMonthModify),
      });
    }
    return options;
  }

  buildEndDateOptions(batchDay: number): any[] {
    const now = new JstDate();
    const endDateModify = batchDay <= now.getDate() ? 1 : 0;
    const billingMonthModify = Number(this.member?.payment?.paymentMethod ?? 0);
    const options = [];
    for (let i = 0; i <= 1; i++) {
      const d = new JstDate(now.getFullYear(), now.getMonth() + i + endDateModify, 1);
      options.push({
        id: d.getFullYear() + '-' + (d.getMonth() + 1),
        name: `${d.getFullYear()}年${('0' + (d.getMonth() + 1)).slice(-2)}月`,
        date: d,
        lastBillingMonth: new JstDate(d.getFullYear(), d.getMonth() - 1 + billingMonthModify),
      });
    }
    return options;
  }

  async save(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.saving || this.completed || this.member?.status != 0) return;
    const now = new JstDate();
    const requestType = Number(this.select.isUseLocker);
    const json: any = {
      studioId: this.member.studio.id,
      memberId: this.member.id,
      requestMonth: now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2),
      status: 2,
      acceptedAt: now,
      requestType,
      beforeLockerNumberId: this.member.lockerNumberId,
    };

    this.saving = true;
    try {
      if (requestType === 0) {
        const startDate = new JstDate(this.select.startDate.date);
        json.startDate = startDate;
        json.afterLockerNumberId = this.select.lockerNumber.id;

        let updateResult: any;
        try {
          updateResult = await this.lockerNumberService.updateMemberId({
            id: this.select.lockerNumber.id,
            memberId: this.member.id,
            unset: 0,
          });
        } catch {
          this.showFeedback('danger', 'ロッカー番号の更新を確認できませんでした。利用状況を確認して、再度申請してください');
          return;
        }
        if (!Array.isArray(updateResult) || updateResult[0] !== 1) {
          this.showFeedback('danger', 'ロッカー番号の更新を確認できませんでした。利用状況を確認して、再度申請してください');
          return;
        }

        const result = await this.notificationService.upsert(json);
        if (!result) {
          this.showFeedback('danger', '諸届申請を更新できませんでした');
          return;
        }
        if (now.getFullYear() === startDate.getFullYear() && now.getMonth() === startDate.getMonth()) {
          await this.memberService.upsert({
            id: this.member.id,
            payment: this.member.payment,
            lockerNumberId: this.select.lockerNumber.id,
            isUseLocker: 0,
          });
        }
        this.completed = true;
        this.resetInputs(form);
        this.showFeedback('success', '諸届申請を更新しました');
      } else if (requestType === 1) {
        const endDate = new JstDate(this.select.endDate.date);
        endDate.setMonth(endDate.getMonth() + 1);
        endDate.setDate(0);
        json.endDate = endDate;
        const result = await this.notificationService.upsert(json);
        if (!result) {
          this.showFeedback('danger', '諸届申請を更新できませんでした');
          return;
        }
        this.completed = true;
        this.resetInputs(form);
        this.showFeedback('success', '諸届申請を更新しました');
      }
    } finally {
      this.saving = false;
    }
  }

  private showFeedback(type: FormFeedback['type'], text: string): void {
    // 旧版 notification-*.js の Flash.create（danger 10秒・それ以外 5秒、閉じる付き）、表示位置はフォーム先頭の <flash-message>
    this.flash.create(type, text, type === 'danger' ? 10000 : 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private resetInputs(form?: NgForm): void {
    this.select = { isUseLocker: null, lockerPlanProduct: null, startDate: null, endDate: null, lockerNumber: null };
    form?.resetForm({
      isUseLocker: null,
      lockerPlanProduct: null,
      lockerNumber: null,
      startDate: null,
      endDate: null,
    });
  }
  private refreshClockDates(): void {
    this.startDateOptions = this.buildStartDateOptions(this.batchDay);
    this.endDateOptions = this.buildEndDateOptions(this.batchDay);
    this.select.startDate = this.select.endDate = null;
  }

}
